export const LaskuriConfiguration = {
  earliestFirstHarvest: 25,
  cutOffAgeBetweenFirstAndNormalHarvest: 35
};
